import { en } from './en';
import { zhCN } from './zh-CN';
import type { Locale } from '../locales';

export const translations = {
  en,
  'zh-CN': zhCN,
} as const;

export type Translations = typeof translations;

export function getTranslation(locale: Locale) {
  return translations[locale] || translations.en;
}
